import './styles.scss'

import { useRef } from 'react';

import { Button } from "@fragments";
import Popper from "@fragments/Popper";
import { IconHelp, IconLogout, IconDownload, IconBrandAndroid, IconBrandApple, IconMoon, IconSun } from "@tabler/icons-react";

import Notifications from "@components/Screen/Header/Notifications";

import { useScreen } from "@hooks/useScreen";
import { useSidebar } from '../../Sidebar/SidebarContext';

import CreateButton from './CreateButton';

import config from '@config';

export default function Actions() {
    const { isMobile } = useSidebar();
    const { resolvedAppearance, setAppearance } = useScreen();

    const downloadBtnRef = useRef();
    const downloadPopperRef = useRef();

    function handleDownloadClick() {
        downloadPopperRef.current?.open(
            [
                {
                    id: 'ios',
                    label: 'Baixar para iOS',
                    icon: <IconBrandApple size={16} />,
                    onClick: () => window.open('https://apps.apple.com/br/app/ginastee/id6448853593'),
                },
                {
                    id: 'android',
                    label: 'Baixar para Android',
                    icon: <IconBrandAndroid size={16} />,
                    onClick: () => window.open('https://play.google.com/store/apps/details?id=com.ginastee'),
                },
            ],
            'bottom-end',
            downloadBtnRef.current
        );
    }

    return (
        <div className="cs-header-actions">
            {!isMobile && <CreateButton />}

            {!isMobile && <Notifications />}

            {isMobile && (
                <Button
                    color="overlay"
                    variant="rounded"
                    icon={resolvedAppearance === 'dark' ? <IconMoon /> : <IconSun />}
                    onClick={() => setAppearance(resolvedAppearance === 'dark' ? 'light' : 'dark')}
                    tooltip="Mudar tema"
                />
            )}

            <Popper controlRef={downloadPopperRef}>
                <Button
                    ref={downloadBtnRef}
                    color="overlay"
                    variant="rounded"
                    icon={<IconDownload />}
                    onClick={handleDownloadClick}
                    tooltip="Baixar o app"
                />
            </Popper>

            <Button
                color="overlay"
                variant="rounded"
                icon={<IconHelp />}
                onClick={() => {
                    window.open(config.help)
                }}
                tooltip="Ajuda"
            />

            {!isMobile && (
                <Button
                    onClick={() => window.logout()}
                    variant="rounded"
                    color="overlay"
                    endIcon={<IconLogout />}
                    tooltip="Sair da plataforma"
                >
                    Sair
                </Button>
            )}
        </div>
    )
}
